import init from '../../../js/init';

const name = 'faq-search';
const selector = '.faq-search';
const searchInputSelector = `${selector}__search input`;
const accordionSelector = '.accordion';
const accordionItemSelector = '.accordion-item';
const accordionItemLabelSelector = `${accordionItemSelector}__label`;
const accordionItemContentSelector = `${accordionItemSelector}__content`;

init(Drupal, name, selector, root => {
  const searchInput = root.querySelector(searchInputSelector);
  const accordions = document.body.querySelectorAll(accordionSelector);

  searchInput.oninput = e => {
    const val = e.target.value.trim().toLowerCase();

    for (const accordion of accordions) {
      const items = [...accordion.querySelectorAll(accordionItemSelector)];

      const filtered = items.filter(item => {
        const labelText = item
          .querySelector(accordionItemLabelSelector)
          .innerText.trim()
          .toLowerCase();
        const contentText = item
          .querySelector(accordionItemContentSelector)
          .innerText.trim()
          .toLowerCase();

        return labelText.includes(val) || contentText.includes(val);
      });

      items.forEach(item => item.classList.add('hidden'));
      filtered.forEach(item => item.classList.remove('hidden'));

      if (filtered.length === 0) accordion.classList.add('hidden');
      else accordion.classList.remove('hidden');
    }
  };
});
